<template>
    <component :is="template">
        <v-sheet>
            <v-btn-toggle tile class="d-flex">
                <v-flex xs4 class="v-btn px-0">
                    <v-btn width="100%" height="80" color="white" elevation="0" to="/mypage/profile">
                        <div class="text-center">
                            <v-icon color="primary" class="my-1 d-block mx-auto">mdi-account-outline</v-icon>
                            <span>회원정보수정</span>
                        </div>
                    </v-btn>
                </v-flex>
                <v-flex xs4 class="v-btn px-0">
                    <v-btn width="100%" height="80" color="white" elevation="0" to="/mypage/shop/carts">
                        <div class="text-center">
                            <v-icon color="primary" class="my-1 d-block mx-auto">mdi-cart-outline</v-icon>
                            <span>장바구니</span>
                        </div>
                    </v-btn>
                </v-flex>
                <v-flex xs4 class="v-btn px-0">
                    <v-btn width="100%" height="80" color="white" elevation="0" to="/mypage/shop/purchases">
                        <div class="text-center">
                            <v-icon color="primary" class="my-1 d-block mx-auto">mdi-text-box-outline</v-icon>
                            <span>주문배송조회</span>
                        </div>
                    </v-btn>
                </v-flex>
            </v-btn-toggle>

            <v-btn-toggle tile class="d-flex">
                <v-flex xs4 class="v-btn px-0">
                    <v-btn width="100%" height="80" color="white" elevation="0" to="/center/questions">
                        <div class="text-center">
                            <v-icon color="primary" class="my-1 d-block mx-auto">mdi-message-question-outline</v-icon>
                            <span>1:1 문의</span>
                        </div>
                    </v-btn>
                </v-flex>
                <v-flex xs4 class="v-btn px-0">
                    <v-btn width="100%" height="80" color="white" elevation="0" to="/mypage/shop/ebooks">
                        <div class="text-center">
                            <v-icon color="primary" class="my-1 d-block mx-auto">mdi-book-outline</v-icon>
                            <!-- <v-img src="/images/icon/ebook.svg"  class="my-1 mx-auto" width="23" /> -->
                            <span>eBook 열람</span>
                        </div>
                    </v-btn>
                </v-flex>
                <v-flex xs4 class="v-btn px-0">
                    <v-btn width="100%" height="80" color="white" elevation="0" to="/mypage/shop/gift-purchases">
                        <div class="text-center">
                            <v-icon color="primary" class="my-1 d-block mx-auto">mdi-book-open-page-variant-outline</v-icon>
                            <span>도서선물내역</span>
                        </div>
                    </v-btn>
                </v-flex>
            </v-btn-toggle>
        </v-sheet>

        <v-sheet class="mt-4">
            <v-btn-toggle tile class="d-flex">
                <v-flex xs4 class="v-btn px-0">
                    <v-btn width="100%" height="80" color="white" elevation="0" to="/mypage/gshop/orders">
                        <div class="text-center">
                            <v-icon color="primary" class="my-1 d-block mx-auto">mdi-wallet-giftcard</v-icon>
                            <span>상품권 구매내역</span>
                        </div>
                    </v-btn>
                </v-flex>
                <v-flex xs4 class="v-btn px-0">
                    <v-btn width="100%" height="80" color="white" elevation="0" to="/mypage/dshop/orders">
                        <div class="text-center">
                            <v-icon color="primary" class="my-1 d-block mx-auto">mdi-truck</v-icon>
                            <div>배송상품</div>
                            <div>구매내역</div>
                        </div>
                    </v-btn>
                </v-flex>
                <v-flex xs4 class="v-btn px-0">
                    <v-btn width="100%" height="80" color="white" elevation="0" to="/mypage/cashes/inquiry">
                        <div class="text-center">
                            <v-icon color="primary" class="my-1 d-block mx-auto">mdi-plus-circle-multiple-outline</v-icon>
                            <span>캐시내역</span>
                        </div>
                    </v-btn>
                </v-flex>
            </v-btn-toggle>
            <v-btn-toggle tile class="d-flex">
                <v-flex xs4 class="v-btn px-0">
                    <v-btn width="100%" height="80" color="white" elevation="0" to="/mypage/cashes/gift">
                        <div class="text-center">
                            <v-icon color="primary" class="my-1 d-block mx-auto">mdi-gift-outline</v-icon>
                            <span>캐시선물내역</span>
                        </div>
                    </v-btn>
                </v-flex>
                <v-flex xs4 class="v-btn px-0">
                    <v-btn width="100%" height="80" color="white" elevation="0" to="/mypage/cashes/charge">
                        <div class="text-center">
                            <v-icon color="primary" class="my-1 d-block mx-auto">mdi-credit-card-plus-outline</v-icon>
                            <span>캐시충전</span>
                        </div>
                    </v-btn>
                </v-flex>
                <v-flex xs4 class="v-btn px-0">
                    <v-btn width="100%" height="80" color="white" elevation="0" to="/mypage/points">
                        <div class="text-center">
                            <v-icon color="primary" class="my-1 d-block mx-auto">mdi-alpha-p-circle-outline</v-icon>
                            <span>포인트내역</span>
                        </div>
                    </v-btn>
                </v-flex>
            </v-btn-toggle>
            <v-btn-toggle tile class="d-flex">
                <v-flex  class="v-btn px-0">
                    <v-btn width="100%" height="80" color="white" elevation="0" to="/mypage/event">
                        <div class="text-center">
                            <v-icon color="primary" class="my-1 d-block mx-auto">mdi-party-popper</v-icon>
                            <span>이벤트 참여내역</span>
                        </div>
                    </v-btn>
                </v-flex>
            </v-btn-toggle>
        </v-sheet>
    </component>
</template>
<script>
import { mdiTextBoxOutline, mdiAlphaPCircleOutline, mdiBookOpenPageVariantOutline, mdiPlusCircleMultipleOutline, mdiMessageQuestionOutline, mdiWalletGiftcard, mdiGiftOutline, mdiCreditCardPlusOutline } from "@mdi/js";
export default {
    data() {
        return {
            mdiCreditCardPlusOutline,
            mdiMessageQuestionOutline,
            mdiTextBoxOutline,
            mdiWalletGiftcard,
            mdiGiftOutline,
            mdiBookOpenPageVariantOutline,
            mdiPlusCircleMultipleOutline,
            mdiAlphaPCircleOutline,
        };
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.mypage}`);
        },
    },
};
</script>

<style scoped>
.v-btn-toggle + .v-btn-toggle {
    margin-top: -1px;
}
</style>